export const feeModifier = {
    initialFeeValue: 0,
    freeDeliveryFee: 0,
    maxDeliveryFeeFee: 15,
    distanceFeeIncrementer: 500,
    bulkBaseFee: 0.5,
    bulkFeeIncrementer: 5,
    extraBulkFeeIncrementer: 12,
    extraBulkFeeSurcharge: 1.2,
    cartValueFreeDelivery: 100,
    smallPurchaseSurcharge: 10,
    longDistanceSurcharge: 1000,
    rushHourFeeIncrementer: 1.2,
    startRushHourFee: 15,
    endRushHourFee: 18,
    rushHourWeekDays: ['Fri']
}